// System Configuration Constants

// Vehicle Movement Event Types
export const VEHICLE_MOVEMENT_EVENTS = {
    FACILITY_ENTRY: 'FACILITY_ENTRY',
    PARKING: 'PARKING',
    SENT_TO_PARKING: 'SENT_TO_PARKING',
    WEIGH_EMPTY: 'WEIGH_EMPTY',
    DOCK_ARRIVAL: 'DOCK_ARRIVAL',
    LOADING_START: 'LOADING_START',
    LOADING_END: 'LOADING_END',
    WEIGH_FULL: 'WEIGH_FULL',
    WEIGHT_ISSUE: 'WEIGHT_ISSUE',
    DOCK_RETURN: 'DOCK_RETURN',
    FACILITY_EXIT: 'FACILITY_EXIT'
};

// Vehicle Movement Event Labels
export const VEHICLE_MOVEMENT_LABELS = {
    [VEHICLE_MOVEMENT_EVENTS.FACILITY_ENTRY]: 'Tesise Giriş',
    [VEHICLE_MOVEMENT_EVENTS.PARKING]: 'Park Alanına Geçiş',
    [VEHICLE_MOVEMENT_EVENTS.SENT_TO_PARKING]: 'Park Alanına Gönderildi',
    [VEHICLE_MOVEMENT_EVENTS.WEIGH_EMPTY]: 'Boş Tartım',
    [VEHICLE_MOVEMENT_EVENTS.DOCK_ARRIVAL]: 'Rampaya Yanaşma',
    [VEHICLE_MOVEMENT_EVENTS.LOADING_START]: 'Yükleme Başladı',
    [VEHICLE_MOVEMENT_EVENTS.LOADING_END]: 'Yükleme Bitti',
    [VEHICLE_MOVEMENT_EVENTS.WEIGH_FULL]: 'Dolu Tartım',
    [VEHICLE_MOVEMENT_EVENTS.WEIGHT_ISSUE]: 'Ağırlık Problemi',
    [VEHICLE_MOVEMENT_EVENTS.DOCK_RETURN]: 'Rampaya Tekrar Yanaşma',
    [VEHICLE_MOVEMENT_EVENTS.FACILITY_EXIT]: 'Tesisten Çıkış'
};

// Reservation Workflow Actions
export const RESERVATION_WORKFLOW_ACTIONS = {
    CREATED: 'CREATED',
    SUBMITTED_TO_TRANSPORTER: 'SUBMITTED_TO_TRANSPORTER',
    APPROVED_BY_TRANSPORTER: 'APPROVED_BY_TRANSPORTER',
    REVISION_REQUESTED: 'REVISION_REQUESTED',
    DRIVER_ASSIGNED: 'DRIVER_ASSIGNED',
    PLATE_ASSIGNED: 'PLATE_ASSIGNED',
    PLANNER_APPROVED_REVISION: 'PLANNER_APPROVED_REVISION',
    PLANNER_REJECTED_REVISION: 'PLANNER_REJECTED_REVISION',
    CANCELLED: 'CANCELLED',
    COMPLETED: 'COMPLETED',
    NOTE_ADDED: 'NOTE_ADDED'
};

// Reservation Workflow Action Labels
export const RESERVATION_WORKFLOW_LABELS = {
    [RESERVATION_WORKFLOW_ACTIONS.CREATED]: 'Rezervasyon Oluşturuldu',
    [RESERVATION_WORKFLOW_ACTIONS.SUBMITTED_TO_TRANSPORTER]: 'Nakliyeciye Gönderildi',
    [RESERVATION_WORKFLOW_ACTIONS.APPROVED_BY_TRANSPORTER]: 'Nakliyeci Onayladı',
    [RESERVATION_WORKFLOW_ACTIONS.REVISION_REQUESTED]: 'Revizyon Talep Edildi',
    [RESERVATION_WORKFLOW_ACTIONS.DRIVER_ASSIGNED]: 'Sürücü Atandı',
    [RESERVATION_WORKFLOW_ACTIONS.PLATE_ASSIGNED]: 'Plaka Atandı',
    [RESERVATION_WORKFLOW_ACTIONS.PLANNER_APPROVED_REVISION]: 'Planlamacı Revizeyi Onayladı',
    [RESERVATION_WORKFLOW_ACTIONS.PLANNER_REJECTED_REVISION]: 'Planlamacı Revizeyi Reddetti',
    [RESERVATION_WORKFLOW_ACTIONS.CANCELLED]: 'İptal Edildi',
    [RESERVATION_WORKFLOW_ACTIONS.COMPLETED]: 'Tamamlandı',
    [RESERVATION_WORKFLOW_ACTIONS.NOTE_ADDED]: 'Not Eklendi'
};

// System Configuration Categories
export const CONFIG_CATEGORIES = {
    VEHICLE_TYPES: 'vehicle_types',
    LOADING_RULES: 'loading_rules',
    DOCK_TYPES: 'dock_types',
    NUMBER_RANGES: 'number_ranges',
    TRANSPORTER_TYPES: 'transporter_types',
    TRANSPORT_MODES: 'transport_modes',
    GENERAL_SETTINGS: 'general_settings'
};

// Loading Calculation Basis
export const LOADING_CALCULATION_BASIS = {
    WEIGHT: 'weight',
    VOLUME: 'volume'
};

export const LOADING_CALCULATION_LABELS = {
    [LOADING_CALCULATION_BASIS.WEIGHT]: 'Ağırlık Bazlı',
    [LOADING_CALCULATION_BASIS.VOLUME]: 'Hacim Bazlı'
};
